import { Instance, types } from 'mobx-state-tree';

export const City = types.model('City', {
  name: types.string
});
export type City = Instance<typeof City>;
